import { useUser } from '@/contexts/UserSession';

const usePerformanceResultAbilities = () => {
    const user = useUser(true);
    const company = user.__typename === 'TenantUser' ? user.company : null;

    const canViewPerformanceResults = () => {
        return !!company?.id || user.__typename === 'SuperAdminUser';
    };

    const canEditOwnPerformanceResults = () => {
        return user.__typename === 'TenantUser';
    };

    const canDeleteOwnPerformanceResults = () => {
        return user.__typename === 'TenantUser';
    };

    const canManagePerformanceResultsForCompany = (companyId: string) => {
        return !!company?.id && company.id === companyId;
    };

    const displayPerformanceResultMenuItem = () => {
        return canViewPerformanceResults();
    };

    return {
        canViewPerformanceResults,
        canEditOwnPerformanceResults,
        canDeleteOwnPerformanceResults,
        canManagePerformanceResultsForCompany,
        displayPerformanceResultMenuItem,
    };
};

export type PerformanceResultAbilities = ReturnType<typeof usePerformanceResultAbilities>;
export default usePerformanceResultAbilities;
